module.exports = require('./lib/type');



//////////////////
// WEBPACK FOOTER
// ./~/type-detect/index.js
// module id = 32
// module chunks = 1 3